import { RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { RulesEntitiesToDisplayNameMap } from '@app/sharedModule/components/rules-dynamic-form/model';
import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { OperatorOption } from './operators-config';
import {
  CART_ATTRIBUTE_KEY_RULE,
  CART_ATTRIBUTE_RULE,
  CART_ATTRIBUTE_VALUE_RULE,
  BARCODE_RULE,
  CART_VALUE_RULE,
  COLLECTION_RULE,
  COUPON_RULE,
  CUSTOMER_ORDER_COUNT_RULE,
  CUSTOMER_SPEND_RULE,
  CUSTOMER_TAGS_RULE,
  DELIVERY_AREA_COUNTRIES_RULE,
  DELIVERY_AREA_DESTINATIONS_RULE,
  DELIVERY_AREA_STATES_RULE,
  DELIVERY_AREA_ZIP_CODES_RULE,
  DEVICE_TYPE_RULE,
  GROSS_MARGIN_RULE,
  HAS_DISCOUNT_RULE,
  ITEM_COUNT_RULE,
  WEIGHT_RULE,
  LOCALE_RULE,
  PRODUCT_TAG_RULE,
  PRODUCT_TYPE_RULE,
  PROPERTIES_KEY_RULE,
  PROPERTIES_VALUE_RULE,
  SELLING_PLAN_RULE,
  SKU_RULE,
  VENDOR_RULE,
  WEEKDAY_SEGMENTATION_RULE,
  TIME_OF_DAY_SEGMENTATION_RULE,
  PRODUCT_METAFIELD_RULE,
  VARIANT_METAFIELD_RULE,
  VARIANT_TITLE_RULE,
  ITEM_SOURCE_RULE,
  ITEM_SOURCE_USAGE_TOKEN_RULE,
  SELECTED_DELIVERY_METHOD_RULE,
} from './common-rule-configs';

export const PRODUCT_RELATED_RULE_ENTITIES: RuleEntity[] = [
  RuleEntity.PRODUCT_TYPE,
  RuleEntity.PRODUCT_TAG,
  RuleEntity.SKU,
  RuleEntity.BARCODE,
  RuleEntity.COLLECTION,
  RuleEntity.VENDOR,
];

type RuleOperatorConfig = {
  fieldType: Fields;
  defaultValue: OperatorOption;
  operators: OperatorOption[];
};

type RuleConfig = {
  entity: RuleEntity;
  entityOperator: RuleOperatorConfig;
  entityParams: any[];
};

const ALL_EXTENSION_RULES: RuleConfig[] = [
  // Delivery area rules
  DELIVERY_AREA_COUNTRIES_RULE,
  DELIVERY_AREA_ZIP_CODES_RULE,
  DELIVERY_AREA_STATES_RULE,
  DELIVERY_AREA_DESTINATIONS_RULE,

  // Customer rules
  CUSTOMER_TAGS_RULE,
  CUSTOMER_ORDER_COUNT_RULE,
  CUSTOMER_SPEND_RULE,

  // Product rules
  PRODUCT_TYPE_RULE,
  PRODUCT_TAG_RULE,
  SKU_RULE,
  BARCODE_RULE,
  VENDOR_RULE,
  COLLECTION_RULE,
  PRODUCT_METAFIELD_RULE,
  VARIANT_METAFIELD_RULE,
  VARIANT_TITLE_RULE,
  PROPERTIES_KEY_RULE,
  PROPERTIES_VALUE_RULE,

  // Cart rules
  CART_VALUE_RULE,
  ITEM_COUNT_RULE,
  WEIGHT_RULE,
  GROSS_MARGIN_RULE,
  HAS_DISCOUNT_RULE,
  CART_ATTRIBUTE_KEY_RULE,
  CART_ATTRIBUTE_VALUE_RULE,
  CART_ATTRIBUTE_RULE,

  // Segmentation rules
  DEVICE_TYPE_RULE,
  WEEKDAY_SEGMENTATION_RULE,
  TIME_OF_DAY_SEGMENTATION_RULE,
  LOCALE_RULE,

  // Plan rules
  SELLING_PLAN_RULE,
  COUPON_RULE,

  // Item-source rules (Cart Control exceptions — PDQ-7681)
  ITEM_SOURCE_RULE,
  ITEM_SOURCE_USAGE_TOKEN_RULE,

  SELECTED_DELIVERY_METHOD_RULE,
];

export const ALL_EXTENSION_RULES_SORTED: RuleConfig[] = ALL_EXTENSION_RULES.sort((a: RuleConfig, b: RuleConfig) => {
  const labelA = RulesEntitiesToDisplayNameMap[a.entity] || a.entity;
  const labelB = RulesEntitiesToDisplayNameMap[b.entity] || b.entity;
  return labelA.localeCompare(labelB);
});

// TODO: Move to @pdqdev/pdq-shared
type ExclusiveOr<T, U> = (T & { [K in keyof U]?: never }) | (U & { [K in keyof T]?: never });

type GetExtensionRulesOptions = {
  customRules?: RuleConfig[];
} & ExclusiveOr<
  {
    excludeRules: RuleEntity[];
  },
  {
    onlyRules: RuleEntity[];
  }
>;

export function getExtensionRules(options?: GetExtensionRulesOptions): RuleConfig[] {
  const { excludeRules = [], customRules = [], onlyRules = [] } = options || {};

  let filtered = ALL_EXTENSION_RULES_SORTED;

  if (onlyRules.length > 0) {
    filtered = ALL_EXTENSION_RULES_SORTED.filter((rule) => onlyRules.includes(rule.entity));
  } else if (excludeRules.length > 0) {
    filtered = ALL_EXTENSION_RULES_SORTED.filter((rule) => !excludeRules.includes(rule.entity));
  }

  return [...filtered, ...customRules];
}
